module.exports = __webpack_public_path__ + "static/scale-model-of-photography-by-roy-allen-stagg-in-round-rock-texas-9e85afdf5410bf660693ee099ef91497.png";